<template>
  <div id="footer-actions" class="footer-section">
    <div>
      <button class="icons-link-mobile text-center" @click="$emit('cancel-sale')">
        <i class="fas fa-window-close footer-section-icon"></i>
        <div class="footer-section-text">CANCEL</div>
      </button>
    </div>
    <div v-if="workstationConfig.options.canVoid">
      <button class="icons-link-mobile text-center" :style="voidStyle" @click="$emit('void-toggle')">
        <i class="fas fa-window-close footer-section-icon"></i>
        <div class="footer-section-text">Void</div>
      </button>
    </div>
    <div>
      <button class="icons-link-mobile text-center" :disabled="transaction && transaction.items && transaction.items.length === 0" @click="$emit('toggle-receipt')">
        <i class="fas fa-print footer-section-icon"></i>
        <div class="footer-section-text">View Receipt</div>
      </button>
    </div>
    <div v-if="workstationConfig.options.canFunctions">
      <button class="icons-link-mobile text-center" :style="isShowFunctionDialog ? 'text-transform:uppercase;color:coral;' : ''" @click="$emit('toggle-functions-dialog')">
        <i class="fas fa-file-invoice-dollar footer-section-icon"></i>
        <div class="footer-section-text">Functions</div>
      </button>
    </div>
     <div v-if="workstationConfig.options.canPickupOrder">
      <button class="icons-link-mobile text-center" @click="$emit('pickup-order')">
        <i class="fas fa-file-medical footer-section-icon"></i>
        <div class="footer-section-text">Pickup Order</div>
      </button>
    </div>
    <div>
      <button class="icons-link-mobile text-center" :style="isShowPaymentDialog ? 'text-transform:uppercase;color:coral;' : ''" :disabled="transaction && transaction.items && transaction.items.length === 0" @click="$emit('pay')">
        <i class="fas fa-file-invoice-dollar footer-section-icon"></i>
        <div class="footer-section-text">PAY</div>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PosFooterDefault',
  props: {
    workstationConfig: { type: Object, required: true },
    transaction: { type: Object, required: true },
    isShowFunctionDialog: { type: Boolean, default: false },
    isShowPaymentDialog: { type: Boolean, default: false },
    voidStyle: { type: String, default: '' }
  }
}
</script>

<style scoped>
.footer-section {
  display: flex;
  justify-content: space-evenly;
  position: fixed;
  bottom: 0px;
  width: 100%;
  padding: 7px 0 3px 0;
  background: #fff;
  left: 0;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, .2);
}
.icons-link-mobile {
  text-align: right;
  font-size: 14px;
  color: #659DBD;
  cursor: pointer;
  margin-bottom: 4px;
  background: none;
  border: none;
  outline: none;
}
.icons-link-mobile:disabled {
  color: #adcbdc;
}
.footer-section-icon {
  font-size: 20px;
}
.footer-section-text {
  font-size: 1em;
}
@media (max-width: 640px) {
  .footer-section-text {
    font-size: 12px !important;
  }
}
</style>
